<template>
	<div class="select-container" @click.prevent="handleSelectOpen">
		<a-select
			:value="selected"
			:placeholder="placeholder"
			:disabled="disabled"
			:open="selectOpen"
			option-filter-prop="children"
			dropdown-class-name="dropdown-class-select"
			class="select-box"
			:getPopupContainer="getPopupContainer()"
			@change="handleChange"
		>
			<template #suffixIcon>
				<i class="icon i-to_more" :class="{ rotate: selectOpen }" @click.stop="handleSelectOpen" />
			</template>
			<a-select-option v-for="(item, index) of inputSettleList" :key="index" :value="item.id" :name="item.name">
				{{ item.name }}
			</a-select-option>
			<div slot="dropdownRender" slot-scope="menu" v-if="list.length">
				<a-input class="search-input" v-model="inputName" :placeholder="inputPlaceholder" @click.stop="(e) => e.target.focus()">
					<i class="icon i-search-new" slot="prefix" type="user" />
				</a-input>
				<v-nodes :vnodes="menu" />
			</div>
			<div slot="notFoundContent" v-else>
				<div class="not-found-container">
					<img class="not-found-img" src="@/assets/images/common/not-found.png" />
					<div class="not-found-content-test">{{ notFoundContentTest }}</div>
				</div>
			</div>
		</a-select>
	</div>
</template>

<script>
import Core from '../../core';
export default {
	name: 'MySelect',
	props: {
		value: {},
		placeholder: { type: String, default: '请选择' },
		disabled: { type: Boolean, default: false },

		parentBody: { type: Boolean, default: true }, // 菜单渲染父节点。是否渲染到 body 上

		inputPlaceholder: { type: String, default: '请输入' },
		notFoundContentTest: { type: String, default: '暂无数据' },

		list: { type: Array, default: [] }, // 所有模板列表
	},
	data() {
		return {
			selected: undefined,

			inputName: '',

			selectOpen: false,
		};
	},
	components: {
		VNodes: {
			functional: true,
			render: (h, ctx) => ctx.props.vnodes,
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(n) {
				console.log('MySelect watch value:', n);
				this.selected = n || undefined;
			},
		},
	},
	computed: {
		// 符合输入名称的模板数据
		inputSettleList() {
			let list = this.list;
			if (this.inputName) {
				list = list.filter((i) => i.name.includes(this.inputName));
			}
			return list;
		},
	},
	mounted() {
		// 将 handleClickOutside 方法作为事件侦听器附加到父元素
		document.addEventListener('click', this.handleClickOutside);
	},
	methods: {
		handleClickOutside(event) {
			// 检查点击事件是否发生在组件外部
			if (!this.$el.contains(event.target)) {
				// 关闭下拉菜单
				this.selectOpen = false;
			}
		},
		// 选择
		handleChange(value = {}) {
			console.log('MySelect handleChange value:', value);

			this.$emit('update', value);
			this.$emit('change', value);
		},
		/**
		 * 自定义弹窗是否打开
		 *
		 * 用于解决 点击输入框  弹窗关闭问题
		 */
		handleSelectOpen() {
			if (this.selectOpen) {
				this.selectOpen = false;
			} else {
				// 开启
				this.selectOpen = this.disabled ? false : true;
			}
		},

		// 菜单渲染父节点。
		getPopupContainer() {
			// 菜单渲染父节点。是否渲染到 body 上
			if (this.parentBody) {
				return () => document.body;
			} else {
				return (triggerNode) => triggerNode.parentNode;
			}
		},
	},
};
</script>

<style lang='scss'>
.select-container {
	position: relative;
}
.not-found-container {
	padding: 14px 0 26px;
	display: flex;
	flex-direction: column;
	align-items: center;
	.not-found-img {
		width: 120px;
	}
	.not-found-content-test {
		color: #8F8F8F;
	}
}
.select-box {
	.ant-select-selection {
		box-shadow: none;
	}
	.ant-select-arrow {
		.i-to_more {
			transform: rotate(90deg);
			transition: all 0.2s;
			&.rotate {
				transform: rotate(270deg);
			}
		}
	}
}
.dropdown-class-select {
	border-radius: 6px;
	box-shadow: 0px 2px 8px -2px rgba(0, 0, 0, 0.04);
	border: 1px solid #ebecf0;
	box-sizing: border-box;
	--color: #222;
	--border-color: #d9e0fb;

	.ant-select-dropdown-menu {
		padding: 6px;
	}

	.ant-select-dropdown-menu-item {
		width: 100%;
		padding: 6px 8px;
		font-size: $fz_bs;
		font-weight: 500;
		border-radius: 4px;
		border: 1px solid transparent;
		background: transparent;
		color: var(--color);
		box-sizing: border-box;

		& + .ant-select-dropdown-menu-item {
			margin-top: 4px;
		}

		&:hover {
			color: var(--color);
			background: #f0f3fa;
		}
	}

	// 选择
	.ant-select-dropdown-menu-item-active {
		border-color: transparent;
	}

	// 已经选择
	.ant-select-dropdown-menu-item-selected {
		// border-color: #2f85f9;
		background: #f0f3fa;
		color: $edit_panel_primary;
		&:hover {
			color: $edit_panel_primary;
		}
	}

	.ant-input-affix-wrapper {
		border-bottom: 1px solid #ebecf0;
		.ant-input-prefix {
			left: 8px;
		}
		.i-search-new {
			color: #8f8f8f;
			font-size: $fz_bs;
		}
	}

	.ant-input {
		border: none;
		padding: 6px 8px;
		box-shadow: none;
	}
	.search-input {
		.ant-input {
			font-size: 13px;
			&::placeholder {
				font-size: 13px;
				color: rgba(143, 143, 143, 0.6);
			}
		}
	}
}
</style>